import * as React from 'react';
import classNames from 'classnames';
import { useMemo } from 'react';
import defaultSpinner from './LottieFiles/wave-dot-loader.json';
import customSpinner from './LottieFiles/custom-wave-dot-loader.json';
import { useLottie } from 'lottie-react';
import { themeStore } from 'Models/ThemeStore';
import { SetLottieColour } from './LottieColourChanger';
import useStore from 'Hooks/useStore';

interface LottieWaveDotLoaderProps {
	className?: string;
}

export function LottieWaveDotLoader({ className }: LottieWaveDotLoaderProps) {
	const options = useMemo(() => {
		// Set the colour of the spinner depending on the application brand colouring
		const colouredSpinner = SetLottieColour(customSpinner, themeStore.config.brandColourPrimary);

		return {
			loop: true,
			autoplay: true,
			animationData: colouredSpinner ?? defaultSpinner,
		};
	}, []);

	const { View } = useLottie(options);
	return <div className={classNames('lottie-wave-loader', className)}>{View}</div>;
}
